import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useTheme } from '@mui/styles';
import { useDispatch } from 'react-redux';
import apis from '@src/apis';
import actions from '@src/redux/actions';
import {
  buildBrandingFromTenant,
  setCachedBranding,
  applyDocumentBranding,
} from '@src/utils/branding';
import { Card } from '../Card';
import SelectColorSet from './SelectColorSet';
import { ProcessHandler } from '../common';

import { StyledConfigTheme } from './index.style';
import { ConfirmDialog } from '../ConfirmDialog';

const ConfigTheme = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [colorSetActive, setColorSetActive] = useState(
    theme.palette.primary.main,
  );
  // the full colorSet object the user picked (sent to the backend on save)
  const [selectedColorSet, setSelectedColorSet] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleGetColorSetActive = (colorSet) => {
    setColorSetActive(colorSet?.primary);
    setSelectedColorSet(colorSet);
    // live preview
    dispatch(actions.theme.changeColor(colorSet));
  };

  const handleCloseChangeColorSet = () => {
    setOpenDialog(false);
  };

  const handleSaveColorSet = () => {
    if (!selectedColorSet) return;
    setOpenDialog(true);
  };

  const handleSaveNewTheme = async () => {
    if (!selectedColorSet) {
      setOpenDialog(false);
      return;
    }

    setLoading(true);
    const res = await apis.tenant.updateTenant({ theme: selectedColorSet });
    setLoading(false);
    setOpenDialog(false);

    if (!res?.status) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          code: res?.code || 0,
          message: res?.message,
        }),
      );
      return;
    }

    // persist to redux + localStorage so it survives reload/login
    const branding = buildBrandingFromTenant(res.result);
    dispatch(actions.theme.setBranding(branding));
    setCachedBranding(branding);
    applyDocumentBranding(branding);

    dispatch(
      actions.noti.push({
        severity: 'success',
        message: 'Đã cập nhật màu chủ đạo',
      }),
    );
  };

  return (
    <Card title="Hiển thị">
      <StyledConfigTheme>
        <SelectColorSet
          colorSetActive={colorSetActive}
          onSelect={handleGetColorSetActive}
        />
        <div className="button">
          <Button
            variant="contained"
            onClick={handleSaveColorSet}
            disabled={!selectedColorSet || loading}
          >
            <ProcessHandler loading={loading}>Lưu thay đổi</ProcessHandler>
          </Button>
        </div>
      </StyledConfigTheme>
      <ConfirmDialog
        open={openDialog}
        title="Chọn màu chủ đạo"
        description="Thay đổi màu của ứng dụng?"
        titleOk="Đồng ý"
        titleCancel="Hủy"
        onCancel={handleCloseChangeColorSet}
        onClose={handleCloseChangeColorSet}
        onOk={handleSaveNewTheme}
      />
    </Card>
  );
};

export default ConfigTheme;
